import { render, staticRenderFns } from "./NewsHall.vue?vue&type=template&id=11361eb0&"
import script from "./NewsHall.vue?vue&type=script&lang=js&"
export * from "./NewsHall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports